import type { GuaEvent } from "@/mocks/events";

const statusMap: Record<GuaEvent["status"], string> = {
  已收束: "bg-secondary-100 text-secondary-900",
  发酵中: "bg-accent-100 text-accent-900",
  进行中: "bg-primary-100 text-primary-800",
  待定论: "bg-background-200 text-foreground-700",
};

const dotMap: Record<GuaEvent["status"], string> = {
  已收束: "bg-secondary-600",
  发酵中: "bg-accent-600",
  进行中: "bg-primary-600",
  待定论: "bg-foreground-400",
};

export default function StatusTag({ status }: { status: GuaEvent["status"] }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${statusMap[status]}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dotMap[status]}`} />
      {status}
    </span>
  );
}